import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './services/auth';
import { dashboardStatsApi } from './services/dashbordStats';
import { assetClassReportApi } from './services/reports';
import { uploadDataApi } from './services/uploadData';
import { usersApi } from './services/users';
import authReducer from './slices/authSlice';

const setUpStore = () => {
  const store = configureStore({
    reducer: {
      [authApi.reducerPath]: authApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [uploadDataApi.reducerPath]: uploadDataApi.reducer,
      [assetClassReportApi.reducerPath]: assetClassReportApi.reducer,
      [dashboardStatsApi.reducerPath]: dashboardStatsApi.reducer,
      auth: authReducer,
    },
    middleware: (getDM) => [
      ...getDM(),
      authApi.middleware,
      usersApi.middleware,
      uploadDataApi.middleware,
      assetClassReportApi.middleware,
      dashboardStatsApi.middleware
    ]
  })
  setupListeners(store.dispatch);
  return store
}

export const store = setUpStore();